const VIEW_STATE_CHANGE = 'viewStateChange'
const LAYERS_CHANGE = 'layersChange'
const INDOOR_MAP_CHANGE = 'lindoorMapChange'
const TOGGLE_POPUPS = 'togglePopups'
const TOGGLE_TRAJECTORY = 'toggleTrajectory'
export function baseMap (
  state = {
    viewState: {
      longitude: 98.82895,
      latitude: 35.98915,
      zoom: 3.5,
      maxZoom: 20,
      minZoom: 3,
      pitch: 0,
      bearing: 0
    },
    layers: []
  },
  action
) {
  switch (action.type) {
    case VIEW_STATE_CHANGE:
    case LAYERS_CHANGE:
    case INDOOR_MAP_CHANGE:
    case TOGGLE_POPUPS:
    case TOGGLE_TRAJECTORY:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export function viewStateChange (data) {
  return { type: VIEW_STATE_CHANGE, payload: data }
}
export function layersChange (data) {
  return { type: LAYERS_CHANGE, payload: data }
}
export function indoorMapChange (data) {
  return { type: INDOOR_MAP_CHANGE, payload: data }
}
export function togglePopups (data) {
  return { type: TOGGLE_POPUPS, payload: data }
}
export function toggleTrajectory (data) {
  return { type: TOGGLE_TRAJECTORY, payload: data }
}
